@let color = isEmptyDistanceError() ? 'red' : 'gray';
<onyx-data-widget
  supheading="labels.kilometers"
  [headingIcon]="{
    name: 'road-filled',
    size: 20,
    color: isEmptyDistanceError() ? 'red' : 'black',
  }"
  [color]="color"
>
  <div heading class="heading">
    <span
      [innerHTML]="
        totalDistance() / 1000
          | number: '1.0-2'
          | numberDecoration: { unit: 'km', color }
      "
    ></span>
  </div>

  <div class="container">
    <div class="list">
      @if (remainingDistance(); as remainingDistance) {
        <div class="item">
          {{ 'labels.remaining' | translate }}

          {{ remainingDistance | onyxDistance }}
        </div>
      }

      <div class="item">
        {{ `${I18N}.loaded` | translate }}

        {{ distance() | onyxDistance }}
      </div>

      @if (emptyDistance(); as emptyDistance) {
        <div class="item" [class.error]="isEmptyDistanceError()">
          {{ 'labels.empty' | translate }}

          {{ emptyDistance.value | onyxDistance }} ·
          {{ emptyDistance.percentage | number: '1.0-2' }}%

          @if (isEmptyDistanceError()) {
            <onyx-icon
              name="alert-circle-filled"
              [size]="16"
              onyxTooltip="labels.emptyDistanceExceeded"
            ></onyx-icon>
          }
        </div>
      }
    </div>
  </div>
</onyx-data-widget>
